import { jsx as _jsx } from "react/jsx-runtime";
import { OLAF, KOALA, BATTLESHIP, LORAX } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { useAllProgress } from '../../../features/userProgress';

const ContentStepIconIndicator = ({
  contentId,
  isActive,
  circleSize
}) => {
  const {
    allProgress,
    allProgressLoading
  } = useAllProgress();
  const hasCompleted = contentId && allProgress.contentProgress[contentId] && allProgress.contentProgress[contentId].completed; // start with defaults, then override as neccessary

  let backgroundColor = KOALA;
  const borderColor = isActive || hasCompleted ? LORAX : BATTLESHIP;
  let color = KOALA;
  const name = hasCompleted ? 'success' : 'blank';

  if (isActive) {
    backgroundColor = OLAF;
    color = hasCompleted ? LORAX : OLAF;
  } else if (hasCompleted) {
    backgroundColor = LORAX;
    color = OLAF;
  }

  return /*#__PURE__*/_jsx(UIIconCircle, {
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderWidth: 2,
    color: color,
    "data-test-id": "content-step-indicator-icon",
    "data-test-progress-is-requesting": allProgressLoading,
    name: name,
    size: circleSize / 2
  });
};

export default ContentStepIconIndicator;